
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MapCard from './MapCard.jsx';

import { getCardByKey } from '../../../selectors';

class MapCardHOC extends Component {
    static propTypes = {
        card: PropTypes.object.isRequired,
        currencySymbol: PropTypes.string.isRequired,
        domain: PropTypes.string.isRequired,
        handleMarkerClick: PropTypes.func.isRequired,
        handleMarkerClose: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        marker: PropTypes.object.isRequired
    }

    render() {
        const {
            card,
            currencySymbol,
            domain,
            handleMarkerClick,
            handleMarkerClose,
            lang,
            marker
        } = this.props;
        return (
            <MapCard
                card={card}
                currencySymbol={currencySymbol}
                domain={domain}
                handleMarkerClick={handleMarkerClick}
                handleMarkerClose={handleMarkerClose}
                lang={lang}
                marker={marker}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    card: getCardByKey(state, ownProps.marker.id),
    currencySymbol: state.searchObject.currency_symbol_left,
    lang: state.lang
});

export default connect(mapStateToProps)(MapCardHOC);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/GoogleMap/MapCardHOC.jsx